import { render } from "./LightningsTable.vue?vue&type=template&id=c3334d06&scoped=true"
import script from "./LightningsTable.vue?vue&type=script&lang=js"
export * from "./LightningsTable.vue?vue&type=script&lang=js"

import "@/assets/table.css?vue&type=style&index=0&id=c3334d06&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3334d06"]])

export default __exports__